import React, { useState, useContext } from "react";
import { HiOutlineMenu } from "react-icons/hi";
import { Link } from "react-router-dom";
import { FaDiscord } from "react-icons/fa";
import {
  AiOutlineTwitter,
  AiOutlineGithub,
  AiOutlineClose,
} from "react-icons/ai";
import { HiMenuAlt4 } from "react-icons/hi";
function MinNav() {
  const [isMenuOpen, setMenuIsOpen] = useState(false);
  return (
    <nav className=" text-primary w-full flex justify-between  lg:hidden">
      <div className="flex items-center">
        {isMenuOpen ? (
          <div
            className="p-4 bg-white  shadow-md 
          w-screen min-h-screen text-start  z-10 absolute right-0 top-0
                  text-2xl font-bold "
          >
            <AiOutlineClose
              className="text-3xl z-50 mb-10 cursor-pointer"
              onClick={() => setMenuIsOpen(!isMenuOpen)}
            />
            <ul id="pop">
              <li className="align-center mr-6 mb-10 flex  transition duration-300 ease-in-out">
                <Link to="/about-courses">عن الشركة</Link>
              </li>
              <li className="align-center  mr-6 flex mb-10 transition  duration-300 ease-in-out">
                <Link to="/community">الدستور</Link>
              </li>
              <li className="align-center  flex mr-6 mb-10 transition duration-300 ease-in-out">
                <Link to="/Blog">في الإعلام</Link>
              </li>
              <li className="align-center  flex mr-6 mb-10 transition duration-300 ease-in-out">
                <Link to="/Blog">ثمانية الخلاقة</Link>
              </li>
              <li className="align-center  flex mr-6 mb-10 transition duration-300 ease-in-out">
                <Link to="/Blog">الوظائف</Link>
              </li>
              <li className="align-center  flex mr-6 mb-10 transition duration-300 ease-in-out">
                <Link to="/Blog">المدونة</Link>
              </li>
              <li className="align-center  flex mr-6 mb-10 transition duration-300 ease-in-out">
                <Link to="/Blog" className="">
                  اتصل بنا
                </Link>
              </li>
              <li
                className=" text-start  p-2 pl-4 pr-4 rounded-full border-2 font-semibold
                                border-primary text-primary inline-block"
              >
                <Link>الذهاب لموقع ثمانية</Link>
              </li>
            </ul>
          </div>
        ) : (
          <>
            <HiMenuAlt4
              className="text-3xl cursor-pointer"
              onClick={() => setMenuIsOpen(!isMenuOpen)}
            />
          </>
        )}
      </div>
    </nav>
  );
}

export default MinNav;
